<!-- @format -->

<template>
  <div :style="{ height: winHeight + 'px' }" class="chat-iframe-container">
    <iframe v-if="iframeUrl" :src="iframeUrl" />
    <div v-else class="chat-loading">Loading…</div>
  </div>
</template>

<script>
import axiosIns from '@/libs/axios'

// 嵌入式 chat 服务（genispace）固定参数。换 user_code，其余参数不动。
const CHAT_BASE = 'https://chat.genispace.ai/embed/chat/db480d56-a74a-448b-8db4-e453a4f4e212'
const CHAT_FIXED_PARAMS = {
  application_id: 'a1e20b0e-acdf-4716-ad29-b971c77e52c3',
  api_key: 'gsp_4zxoyfn0jiuwzaohwbyz6s',
  theme: 'light',
  lang: 'en',
}

export default {
  data() {
    return {
      winHeight: 600,
      iframeUrl: '',
    }
  },
  mounted() {
    this.winHeight = document.body.clientHeight - 130
    this.loadIframe()
  },
  methods: {
    async loadIframe() {
      try {
        const response = await axiosIns({ url: 'user/userinfo', method: 'get' })
        const id = response && response.data && response.data.id
        const params = new URLSearchParams({
          ...CHAT_FIXED_PARAMS,
          user_code: id != null ? String(id) : '',
        })
        this.iframeUrl = `${CHAT_BASE}?${params.toString()}`
      } catch (e) {
        // 拿不到 user_id 时仍渲染 iframe（user_code 留空），避免整个页面空白
        const params = new URLSearchParams({ ...CHAT_FIXED_PARAMS, user_code: '' })
        this.iframeUrl = `${CHAT_BASE}?${params.toString()}`
        // eslint-disable-next-line no-console
        console.error('chat iframe: failed to load user info', e)
      }
    },
  },
}
</script>

<style scoped>
.chat-iframe-container {
  position: relative;
  width: 100%;
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.chat-loading {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}
</style>
